
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Loader2 } from "lucide-react";

interface DataConnectionFormTooltipProps {
  connectorIncomplete: boolean;
  linkedConnectorsLength: number;
  isSubmitting: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const DataConnectionFormTooltip = ({
  connectorIncomplete,
  linkedConnectorsLength,
  isSubmitting,
  onClick,
  children
}: DataConnectionFormTooltipProps) => {
  const isDisabled = connectorIncomplete || linkedConnectorsLength === 0 || isSubmitting;
  
  const getTooltipMessage = () => {
    if (isSubmitting) {
      return "Form is being submitted...";
    }
    if (linkedConnectorsLength === 0) {
      return "Please add at least one data connection";
    }
    if (connectorIncomplete) {
      return "One or more connections are incomplete or broken";
    }
    return "";
  };

  if (!isDisabled) {
    return (
      <Button 
        onClick={onClick} 
        disabled={isSubmitting}
        className="bg-brand-primary text-white px-6 py-2 rounded-md hover:bg-brand-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Processing...
          </>
        ) : (
          children
        )}
      </Button>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button 
              onClick={onClick} 
              disabled={isDisabled}
              className="bg-brand-primary text-white px-6 py-2 rounded-md hover:bg-brand-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Processing...
                </>
              ) : (
                children
              )}
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{getTooltipMessage()}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default DataConnectionFormTooltip;
